import { render } from "./aiAddItemConfirmModel.vue?vue&type=template&id=768332e0"
import script from "./aiAddItemConfirmModel.vue?vue&type=script&lang=js"
export * from "./aiAddItemConfirmModel.vue?vue&type=script&lang=js"

import "./aiAddItemConfirmModel.vue?vue&type=style&index=0&id=768332e0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__